<template>
  <div>
    <b-row>
      <b-col class="mx-auto" cols="12" sm="10" md="8">
        <b-container>
          <b-button v-if="!viewAdd && !viewEdit" class="button btn-blue my-4" @click="addPressed">
            <font-awesome-icon class="agv-button-icon" icon="plus" />
            <span>{{ $t("general.newresolution") }}</span>
          </b-button>
        </b-container>

        <appResolution
          v-if="viewAdd"
          :is-new="true"
          :resolution-catalog-id="resolutionCatalogId"
          :last-position="lastPosition"
          @cancel="cancelPressed"
        />
        <appResolution
          v-else-if="viewEdit"
          :is-new="false"
          :resolution-id="resolutionId"
          :resolution-catalog-id="resolutionCatalogId"
          :last-position="lastPosition"
          @cancel="cancelPressed"
        />

        <!-- NEW TABLE -->
        <appTable
          v-else
          ref="mr-table"
          class="agv-table"
          :items="tableData"
          :resolution-catalog-id="resolutionCatalogId"
          @editPressed="editPressed"
          @deletePressed="DELETE_RESOLUTION"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import appResolution from "./Resolution";

import ResolutionMW from "@/middlewares/Resolution";
import ResolutionORM from "@/store/orm-axios/models/Resolution";

export default {
  components: {
    appResolution,
    appTable: () => import("./Table"),
  },
  props: {
    resolutionCatalogId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ResolutionMW: ResolutionMW,
      ResolutionORM: ResolutionORM,
      viewAdd: false,
      viewEdit: false,
      resolutionId: null,
    };
  },
  computed: {
    tableData() {
      return ResolutionORM.query()
        .where("agency_id", this.agencyId)
        .where("parent_resolution_id", null)
        .where("resolution_catalog_id", this.resolutionCatalogId)
        .orderBy("position", "asc")
        .withAllRecursive(0) // NOTE: limit recursiveness ...
        .get();
    },
    lastPosition() {
      if (this.tableData && this.tableData.length > 0) {
        let result = this.$_.sortBy(this.tableData, function (obj) {
          return obj.position;
        });
        // console.log(result[result.length - 1]);
        return result[result.length - 1].position;
      } else {
        return 0;
      }
    },
  },
  watch: {
    viewAdd(val) {
      this.$emit("hideParentActionButtons", val);
    },
    viewEdit(val) {
      this.$emit("hideParentActionButtons", val);
    },
  },
  beforeDestroy() {
    this.$emit("hideParentActionButtons", false);
  },
  methods: {
    cancelPressed() {
      this.viewAdd = false;
      this.viewEdit = false;
      this.resolutionId = null;
    },
    addPressed() {
      this.viewAdd = true;
    },
    editPressed(e) {
      this.resolutionId = e.id;
      this.viewEdit = true;
    },
    DELETE_RESOLUTION(item) {
      delete item["key"];
      // delete from tableData
      this.$swal({
        info: "question",
        title: this.$t("general.delete_question"),
        text: "",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("general.message_yes"),
        cancelButtonText: this.$t("general.message_no"),
        reverseButtons: true,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-primary btn-lg",
        cancelButtonClass: "btn btn-light btn-lg",
      })
        .then(res => {
          if (res.value) {
            var index = this.$_.findIndex(this.tableData, { id: item.id });
            this.tableData.splice(index, 1);
            ResolutionMW.DELETE(item)
              .then(res => {})
              .catch(err => {
                // In case of error, add item back to array
                this.tableData.splice(index, 0, item);
                console.log("error at delete", item, err);
              });
            // console.log("YES");
          } else {
            // console.log("NO");
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    },
  },
};
</script>
